<div *ngIf="isOpen" [@popup] class="container" [ngStyle]="{'left': position.left||'auto', 'right': position.right||'auto', 'top': position.top||'auto', 'bottom': position.bottom||'auto' }">
  <div class="header"><ng-content select="[header],header"></ng-content></div>
  <div class="content"><ng-content select="[content],main"></ng-content></div>
  <div class="action"><ng-content select="[buttons],footer"></ng-content></div>
</div>


// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/info-popup/info-popup.component.html